import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const LockClearSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
    <path
      d='M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z'
      stroke='url(#paint0_linear_541_22413)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11'
      stroke='url(#paint1_linear_541_22413)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_541_22413'
        x1='3'
        y1='11'
        x2='21.6141'
        y2='12.1619'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_541_22413'
        x1='7'
        y1='2'
        x2='17.3629'
        y2='2.43923'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);

export const LockClearIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LockClearSvg} {...props} />
);
